/* @flow */

import { topBarHeight } from 'src/shared/app/nav/style/nav.style';

export default {
  root: {
    paddingTop: topBarHeight,
  },
};
